export default __webpack_public_path__ + "static/media/wallet-black.a917eab6.svg";